module.exports = __webpack_public_path__ + "34736292/img/chevron-down-icon.5542f65c.svg";